<template>
	<v-dialog
		v-model="showSogOrder"
		width="900"
		persistent
	>
		<v-card class="pb-4 remove-overflow">
			<v-card-title class="primary">
				<span class="white--text">Sign On Glass Orders</span>
			</v-card-title>

		<v-card-text>
			<v-row>
				<v-col cols="2" :style="$vuetify.breakpoint.sm ? 'display: none' : ''"></v-col>
				<v-col cols="5" :style="$vuetify.breakpoint.sm ? 'display: none' : ''"></v-col>
				<v-col cols="12" md="5">
					<app-search class="mb-4" @search="search"></app-search>
				</v-col>
			</v-row>

			<app-table ref="table" :component="'new'" :options="options" :headers="headers" :items="items" :keyword="keyword" :cols="6" :orderDialog="true" @selected="setSelected($event)"></app-table>
		</v-card-text>

		<v-card-actions class="mt-1 mx-4">
			<v-row>
				<v-col class="text-right py-0" cols="12">
					<v-btn class="mr-3 primary" :style="$vuetify.breakpoint.xs ? 'width: 100%' : ''" :disabled="disableButton" @click="setOrder()">Create Optus NBN Order</v-btn>
					<v-btn @click="close()" :style="$vuetify.breakpoint.xs ? 'width: 100%; margin-top: 18px' : ''">Close</v-btn>
				</v-col>
			</v-row>
		</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { Order } from "@/models/Order";
export default {
	name: "SignonglassOrders",
	props: {
		showSogOrder: { type: Boolean, required: true },
		items: { type: Array }
	},
	data: () => ({
		disableButton: true,
		selected: {},
		keyword: "",
		options: {
			sortDesc: true,
			page: 1,
			rowsPerPage: 10,
			sortBy: ['internetID'],
			rowsPerPageItems: [10, 20, 30, 40, -1]
		},
		headers: [
			{
				text: "SOG Order No.",
				sortable: false,
				value: "orderID"
			},
			{
				text: "Customer Name",
				sortable: false,
				value: "orderString"
			},
			{
				text: "Partner Name",
				sortable: false,
				value: "dealerFullName"
			},
			{
				text: "NBN Plan(s)",
				sortable: false,
				value: "ratePlanDescription"
			},
			{
				text: "Ticket",
				sortable: false,
				value: "kayakoConversation"
			},
			{
				text: "Select",
				sortable: false,
				value: "actionsSOG"
			}
		]
	}),
	methods: {
		search(keyword){
			let vm = this;
			vm.keyword = keyword;
		},
		setSelected(item){
			let vm = this;
			vm.selected = item;
			vm.disableButton = false;
		},
		setOrder(){
			let vm = this;

			let orderDetails = new Order ({
			locationId: "",
			orderType: "",
			customerAuthDate: vm.selected.createdDate,
			requestedSpeed: vm.selected.speedRequested,
			contractTerm: vm.selected.contractTerm,
			customer: {
			firstName: vm.selected.customerFirstName,
			lastName: vm.selected.customerSurname,
			contactNo: vm.selected.customerMobile,
			email: vm.selected.customerEmail
			},
			operatorContactEmail: vm.selected.dealerEmail,
			operatorContactNumber: vm.selected.contactMobile,
			serviceId: "",
			accessLoopId: "",
			operatorFirstname: "",
			operatorSurname: "",
			customerReference: vm.selected.orderID,
			cpiID: "",
			ntdID: "",
			unidPortID: "",
			installationWorkforce: "",
			portingNumber: 0,
			specialInstructions: "",
			deliveryInstructions: ""
			})

			vm.$emit("createOrder", orderDetails);
		},
		close() {
			let vm = this;
			vm.$refs.table.resetSelected();
			vm.disableButton = true;
			vm.$emit("close");
		}
	}
}
</script>

<style lang="scss" scoped>
.remove-overflow {
	overflow: hidden
}
</style>